import React from 'react';
import { Content, Title, InputFormTable, Text } from 'components';
import { Input, DatePicker, Radio, Tooltip, InputNumber, Flex } from 'antd';
import Formatter from 'utils/Formatter';
import dayjs from 'dayjs';
import { QuestionCircleTwoTone } from '@ant-design/icons';

const CouponInfoForm = (props) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  const { inputValue, callback, onChange, type = 'menu', style = {} } = props;

  /* ===== State ===== */
  /* ===== Hooks ===== */
  /* ===== Function ===== */
  /* ===== Variable ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    subTitle: {
      fontSize: 17,
      fontWeight: 500,
      lineHeight: '141%',
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
  };

  const couponForm = [
    {
      label: '쿠폰명',
      required: true,
      form: [
        {
          input: (
            <Input
              size="large"
              placeholder="쿠폰명 입력"
              value={inputValue?.coupon_name}
              style={{ ...styles.form.input.large, width: 400 }}
              onChange={(e) =>
                onChange('coupon_name', e.target.value, inputValue, callback)
              }
            />
          ),
        },
      ],
    },
    {
      label: '쿠폰 발급 코드',
      required: true,
      form: [
        {
          input: (
            <Input
              size="large"
              placeholder="쿠폰 발급 코드"
              value={inputValue?.coupon_code}
              style={{ ...styles.form.input.large, width: 400 }}
              disabled
            />
          ),
        },
      ],
    },
    ...(type === 'menu'
      ? [
          {
            label: '매장 이용 설명',
            form: [
              {
                fullscreen: true,
                input: (
                  <Input.TextArea
                    size="large"
                    placeholder="매장 이용 설명 입력"
                    value={inputValue?.unavailable_store}
                    onChange={(e) =>
                      onChange(
                        'unavailable_store',
                        e.target.value,
                        inputValue,
                        callback
                      )
                    }
                    style={{
                      width: '80%',
                      height: 60,
                      marginBottom: 10,
                    }}
                    count={{
                      max: 255,
                      show: true,
                    }}
                  />
                ),
              },
            ],
          },
        ]
      : []),
    {
      label: '메모 설명',
      form: [
        {
          fullscreen: true,
          input: (
            <Input.TextArea
              size="large"
              placeholder="메모 설명 입력"
              value={inputValue?.note}
              onChange={(e) =>
                onChange('note', e.target.value, inputValue, callback)
              }
              style={{
                ...styles.form.input.large,
                width: '80%',
                height: 60,
                marginBottom: 10,
              }}
              count={{
                max: 255,
                show: true,
              }}
            />
          ),
        },
      ],
    },
    {
      label: '이익 설명',
      form: [
        {
          fullscreen: true,
          input: (
            <Input.TextArea
              size="large"
              placeholder="이익 설명 입력"
              value={inputValue?.benefit}
              onChange={(e) =>
                onChange('benefit', e.target.value, inputValue, callback)
              }
              style={{
                ...styles.form.input.large,
                width: '80%',
                height: 60,
                marginBottom: 10,
              }}
              count={{
                max: 255,
                show: true,
              }}
            />
          ),
        },
      ],
    },
    {
      label: '쿠폰 기준 설명',
      form: [
        {
          fullscreen: true,
          input: (
            <Input.TextArea
              size="large"
              placeholder="쿠폰 기준 설명 입력"
              value={inputValue?.standard}
              onChange={(e) =>
                onChange('standard', e.target.value, inputValue, callback)
              }
              style={{
                ...styles.form.input.large,
                width: '80%',
                height: 60,
                marginBottom: 10,
              }}
              count={{
                max: 255,
                show: true,
              }}
            />
          ),
        },
      ],
    },
    {
      label: '전체 발급 가능 수량',
      required: true,
      form: [
        {
          input: (
            <>
              <Input
                size="large"
                value={
                  inputValue?.coupon_issue_num
                    ? inputValue?.coupon_issue_num
                    : inputValue?.coupon_issue_num === 0
                    ? 0
                    : ''
                }
                placeholder="숫자만 입력"
                style={{ ...styles.form.input.large }}
                onChange={(e) =>
                  onChange(
                    'coupon_issue_num',
                    parseInt(Formatter.numberOnly(e.target.value)),
                    inputValue,
                    callback
                  )
                }
              />
              <Flex vertical>
                <p style={{ fontSize: '14px', color: '#D33444' }}>
                  * 전체 발급 가능 수량 초과 시 쿠폰은 발급되지 않습니다.
                </p>
                <p style={{ fontSize: '13px', color: '#D33444' }}>
                  예{') '}
                  전체 발급 수량 10 / 현재 발급 수량 5 / 발급해야할 수량 9{' '}
                  {'=> '}
                  발급 x
                </p>
                <p style={{ fontSize: '14px', color: '#D33444' }}>
                  * 무제한 발급 시 0을 입력해주세요.
                </p>
                {/* <Text size={16} color={'#D33444'}>
                  * 전체 발급 가능 수량 초과 시 쿠폰은 발급되지 않습니다. 예
                  {') '}
                  전체 발급 수량 10 / 현재 발급 수량 5 / 발급해야할 수량 9{' '}
                  {'=> '}
                  발급 x
                </Text>
                <Text size={16} color={'#D33444'}>
                  * 무제한 발급 시 0을 입력해주세요.
                </Text> */}
              </Flex>
            </>
          ),
        },
      ],
    },

    {
      label: '최소사용금액',
      required: true,
      form: [
        {
          input: (
            <>
              <Input
                value={
                  inputValue?.minimum_price
                    ? inputValue?.minimum_price
                    : inputValue?.minimum_price === 0
                    ? 0
                    : ''
                }
                size="large"
                placeholder="숫자만 입력"
                style={{ ...styles.form.input.medium }}
                onChange={(e) =>
                  onChange(
                    'minimum_price',
                    parseInt(Formatter.numberOnly(e.target.value)),
                    inputValue,
                    callback
                  )
                }
              />
              <p>원</p>
            </>
          ),
        },
      ],
    },
    {
      label: '쿠폰 기간',
      form: [
        {
          input: (
            <>
              <DatePicker
                size="large"
                placeholder=""
                format={'YYYY-MM-DD'}
                value={
                  inputValue?.start_date ? dayjs(inputValue?.start_date) : ''
                }
                style={{ ...styles.form.input.large }}
                onChange={(date) =>
                  onChange('start_date', date, inputValue, callback)
                }
              />
              <p>~</p>
            </>
          ),
        },
        {
          input: (
            <>
              <DatePicker
                size="large"
                placeholder=""
                format={'YYYY-MM-DD'}
                value={inputValue?.end_date && dayjs(inputValue?.end_date)}
                style={{ ...styles.form.input.large }}
                onChange={(date) =>
                  onChange('end_date', date, inputValue, callback)
                }
              />
              {/* TODO: 나중에 주석 풀기 */}
              {/* <Text size={16} color={'#D33444'}>
                {inputValue?.payment_type === 'DOWNLOAD'
                  ? '* 다운로드가 가능한 기간 및 다운로드된 쿠폰의 사용 가능 기간을 나타냅니다.'
                  : inputValue?.payment_type === 'STAMP'
                  ? '* 스탬프일 경우에는 쿠폰 사용 기간에 영향을 주지 않습니다. 만료타입을 만료일 기준으로 설정시에만 종료일자를 기준으로 만료됩니다.'
                  : '* 쿠폰의 사용 가능 기간을 나타냅니다.'}
              </Text> */}
            </>
          ),
        },
      ],
    },
    {
      label: '만료일자(일)',
      required: inputValue?.expiration_type === 'ROLLING',
      form: [
        {
          input: (
            <>
              <Input
                value={
                  inputValue?.expiration_date
                    ? inputValue?.expiration_date
                    : inputValue?.expiration_date === 0
                    ? 0
                    : ''
                }
                size="large"
                placeholder="숫자만 입력"
                style={{ ...styles.form.input.medium }}
                onChange={(e) =>
                  onChange(
                    'expiration_date',
                    parseInt(Formatter.numberOnly(e.target.value)),
                    inputValue,
                    callback
                  )
                }
              />
              <p>일</p>
            </>
          ),
        },
      ],
    },
    {
      label: '만료타입',
      form: [
        {
          input: (
            <>
              <Radio.Group
                value={
                  inputValue?.expiration_type && inputValue?.expiration_type
                }
                onChange={(e) =>
                  onChange(
                    'expiration_type',
                    e.target.value,
                    inputValue,
                    callback
                  )
                }
              >
                <Radio value={'ROLLING'}>발급일 기준</Radio>
                <Radio value={'FIXED'}>만료일 기준</Radio>
              </Radio.Group>
              <p style={{ fontSize: '12px', color: '#D33444' }}>
                {inputValue?.expiration_type === 'FIXED'
                  ? '* 만료일 기준으로 설정시 쿠폰의 종료일자를 기준으로 만료됩니다.'
                  : '* 발급일 기준으로 설정시 발급일 + 만료일자를 기준으로 만료됩니다.'}
              </p>
              {/* <Text size={16} color={'#D33444'}>
                {inputValue?.expiration_type === 'FIXED'
                  ? '* 만료일 기준으로 설정시 쿠폰의 종료일자를 기준으로 만료됩니다.'
                  : '* 발급일 기준으로 설정시 발급일 + 만료일자를 기준으로 만료됩니다.'}
              </Text> */}
            </>
          ),
        },
      ],
    },
    ...(type === 'product'
      ? [
          {
            label: (
              <Tooltip title="프로모션 중복할인 가능여부">
                중복할인여부 <QuestionCircleTwoTone />
              </Tooltip>
            ),
            form: [
              {
                input: (
                  <>
                    <Radio.Group
                      value={
                        inputValue?.is_duplication && inputValue?.is_duplication
                      }
                      onChange={(e) =>
                        onChange(
                          'is_duplication',
                          e.target.value,
                          inputValue,
                          callback
                        )
                      }
                    >
                      <Radio value={'Y'}>가능</Radio>
                      <Radio value={'N'}>불가능</Radio>
                    </Radio.Group>
                  </>
                ),
              },
            ],
          },
        ]
      : []),
    {
      label: '바우처 타입',
      form: [
        {
          input: (
            <>
              <Radio.Group
                options={[
                  { label: '금액 할인권', value: 'AMOUNT_DISCOUNT' },
                  { label: '퍼센트 할인권', value: 'PERCENT_DISCOUNT' },
                  ...(type === 'menu'
                    ? [{ label: '교환권', value: 'EXCHANGE' }]
                    : []),
                ]}
                value={inputValue?.voucher_type && inputValue?.voucher_type}
                onChange={(e) =>
                  onChange('voucher_type', e.target.value, inputValue, callback)
                }
                optionType="button"
                buttonStyle="solid"
              />
            </>
          ),
        },
      ],
    },
    {
      label: '지급유형',
      form: [
        {
          input: (
            <>
              <Radio.Group
                options={[
                  { label: '수동', value: 'MANUAL' },
                  { label: '자동', value: 'AUTOMATIC' },
                  { label: '다운로드', value: 'DOWNLOAD' },
                  ...(type === 'menu'
                    ? [{ label: '스탬프', value: 'STAMP' }]
                    : []),
                ]}
                value={inputValue?.payment_type && inputValue?.payment_type}
                onChange={(e) =>
                  onChange('payment_type', e.target.value, inputValue, callback)
                }
                optionType="button"
                buttonStyle="solid"
              />
            </>
          ),
        },
      ],
    },
    ...(type === 'menu'
      ? [
          {
            label: '쿠폰 타입',
            form: [
              {
                input: (
                  <>
                    <Radio.Group
                      options={[
                        { label: '전체', value: 'ALL' },
                        // { label: '프리퀀시', value: 'FREQUENCY' },
                        { label: '메뉴', value: 'MENU' },
                        { label: 'MD', value: 'MD' },
                        // { label: '상품', value: 'PRODUCT' },
                        { label: '디저트', value: 'DESSERT' },
                      ]}
                      value={inputValue?.coupon_type && inputValue?.coupon_type}
                      onChange={(e) =>
                        onChange(
                          'coupon_type',
                          e.target.value,
                          inputValue,
                          callback
                        )
                      }
                      optionType="button"
                      buttonStyle="solid"
                    />
                  </>
                ),
              },
            ],
          },
        ]
      : []),
    {
      //NOTE: 발급유형 자동 시
      key: 'issue_event',
      label: '발급 시점',
      form: [
        {
          input: (
            <>
              <Radio.Group
                options={[
                  { label: '회원가입', value: 'SIGNUP' },
                  ...(type === 'menu'
                    ? [{ label: '오더 첫 구매', value: 'FIRST_PURCHASE' }]
                    : [
                        {
                          label: '쇼핑몰 첫 구매',
                          value: 'SHOP_FIRST_PURCHASE',
                        },
                      ]),
                  { label: '생일', value: 'BIRTH_DAY' },
                  // { label: '상품 후기', value: 'REVIEW_POSTED' },
                  // { label: '주문 완료', value: 'ORDER_COMPLETED' },
                  // { label: '배송 완료', value: 'DELIVERY_COMPLETED' },
                ]}
                value={inputValue?.issue_event && inputValue?.issue_event}
                onChange={(e) =>
                  onChange('issue_event', e.target.value, inputValue, callback)
                }
                optionType="button"
                buttonStyle="solid"
                disabled={inputValue?.payment_type !== 'AUTOMATIC'}
              />
            </>
          ),
        },
      ],
    },
    {
      label: '회원당 발급 수량',
      form: [
        {
          input: (
            <>
              <InputNumber
                disabled={
                  !['AUTOMATIC', 'DOWNLOAD'].includes(inputValue.payment_type)
                }
                size="large"
                value={
                  inputValue?.per_user_limit ? inputValue?.per_user_limit : 1
                }
                min={1}
                placeholder="숫자만 입력"
                style={{ ...styles.form.input.medium }}
                onChange={(e) =>
                  onChange('per_user_limit', e, inputValue, callback)
                }
              />
              <p style={{ fontSize: '12px', color: '#D33444' }}>
                * 등급 혜택에 따른 쿠폰 발급, 관리자 수동 발급에는 영향을 주지
                않습니다.
              </p>
            </>
          ),
        },
      ],
    },
    {
      label: '재발급 가능 여부',
      form: [
        {
          input: (
            <>
              <Radio.Group
                value={inputValue?.is_reissue && inputValue?.is_reissue}
                disabled={inputValue.payment_type !== 'DOWNLOAD'}
                onChange={(e) =>
                  onChange('is_reissue', e.target.value, inputValue, callback)
                }
              >
                <Radio value={'Y'}>재발급 가능</Radio>
                <Radio value={'N'}>재발급 불가능</Radio>
              </Radio.Group>
            </>
          ),
        },
      ],
    },
    {
      label: '사용처리여부',
      form: [
        {
          input: (
            <>
              <Radio.Group
                value={inputValue?.is_used && inputValue?.is_used}
                onChange={(e) =>
                  onChange('is_used', e.target.value, inputValue, callback)
                }
              >
                <Radio value={'Y'}>사용처리</Radio>
                <Radio value={'N'}>사용처리 안함</Radio>
              </Radio.Group>
            </>
          ),
        },
      ],
    },
  ];

  /* ===== Hooks ===== */
  /* ===== Render ===== */
  return (
    <Content
      maxWidth={'100%'}
      padding={20}
      borderRadius={4}
      style={{ marginBottom: 40, ...style }}
    >
      <Title style={{ ...styles.subTitle }}>쿠폰 기본 정보</Title>
      <InputFormTable form={couponForm} />
    </Content>
  );
};

export default CouponInfoForm;
